<template>
    <span class="badge" :style="{ '--badge-color': color }">
        <slot></slot>
    </span>
</template>

<script>
export default {
    name: 'badgeUI',
    props: {
        color: {
            type: String,
            default: null
        }
    }
};
</script>

<style scoped>
.badge {
    background-color: var(--badge-color, var(--color-primary));
    color: #fff;
    padding: calc(var(--spacing-xs) / 2) var(--spacing-xs);
    border-radius: var(--radius-sm);
    font-size: var(--text-xs);
    flex-shrink: 0;
    line-height: 1;
}
</style>